import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Avatar, Button, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import "./Header.css";

const Header = ({ children, hasHiddenAuthButtons }) => {

  const history = useHistory();

  const handleLogin = ()=>{
    history.push("/login")
  }

  const handleRegister = ()=>{
    history.push("/register")
  }
  
  // const handleLogout = ()=>{
  //   localStorage.clear();
  //   window.location.reload(); //hard refresh the page
  // }
  const logout = () =>{
    localStorage.removeItem("token");
    localStorage.removeItem("username");
    localStorage.removeItem("balance");
    history.push("/");
    window.location.reload();
  }
  
  if(hasHiddenAuthButtons){
    return(
<Box className="header">
        <Box className="header-title">
            <img src="logo_light.svg" alt="QKart-icon"></img>
        </Box>
        {children}
        <Button
          className="explore-button"
          startIcon={<ArrowBackIcon />}
          variant="text"
          onClick={() => history.push("/")}
        >
          Back to explore
        </Button>
      </Box>
    )
  }
  // const username = localStorage.getItem("username");
    return (
      <Box className="header">
        <Box className="header-title">
          <img src="logo_light.svg" alt="QKart-icon"></img>
        </Box>
        {children}
        <Stack direction="row" spacing={2} alignItems="center">{localStorage.getItem("username") ? 
        (
          <>
          <Avatar src="avatar.png" alt={localStorage.getItem("username") || "profile"}>
          </Avatar>
          <p className="username-text">{localStorage.getItem("username")}</p>
          <Button type="primary" onClick={logout}>Logout</Button>
          </>
        ) : (
          <>
          <Button onClick={handleLogin} className="explore-button">Login</Button>
          <Button variant="contained" className="button" onClick={handleRegister}>Register</Button>
          </>
        )}</Stack>
      </Box>
    
    );
};

export default Header;

// localStorage.getItem("token") ? <Stack spacing={2} direction={"row"} justifyContent={"flex-end"} alignItems={"center"} padding={"15px"}  >
      //     <img width={30} height={30} src="avatar.png"  alt={username} style={{marginRight:"10px"}}/>{localStorage.getItem("username")}
      //     <Button onClick={handleLogout}>Logout</Button>
      // </Stack>: 
      // <Stack spacing={2} direction={"row"} justifyContent={"flex-end"} alignItems={"center"} padding={"15px"}>
      //   <Button className="explore-button" onClick={handleLogin}>Login</Button>
      //   <Button variant="contained" className="button" onClick={handleRegister}>Register</Button>
      // </Stack> 
